import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.toast');
import { OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-toast',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.toast/view.scss */
:host {
  display: block;
}

@keyframes slideDown {
  from {
    transform: translateY(-16px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`],
})
export class ComponentToastComponent implements OnInit {
    @Input() pokeToast: string = '';
    @Input() noteToast: any = null;
    @Input() successToast: string = '';
    @Input() adminNotificationToast: any = null;
    @Input() webinarToast: string = '';
    @Input() webinarRoomName: string = '';
    @Input() webinarJoining: boolean = false;
    @Output() noteToastClick = new EventEmitter<void>();
    @Output() webinarJoin = new EventEmitter<void>();
    @Output() webinarToastClose = new EventEmitter<void>();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }
}

export default ComponentToastComponent;